import React, { FC } from "react";
import CustomTooltip from "../CustomTooltip";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DynamicTable from "../dynamicTable/DynamicTable";
import { TABLE_HEADER_ARRAY } from "../../utils/Types";

interface TableChartProps {
  title?: string;
  tooltipTitle?: string;
  headers: TABLE_HEADER_ARRAY;
  rowData: Array<any>;
  isLoading?: boolean;
}

const TableChart: FC<TableChartProps> = ({
  title,
  tooltipTitle,
  headers,
  rowData,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {title && (
        <CustomTooltip title={t(tooltipTitle ?? title)}>
          <Typography variant="h6" color="custom.foreground.secondary" mb={1}>
            {t(title)}
          </Typography>
        </CustomTooltip>
      )}
      <DynamicTable
        headers={headers}
        rowData={rowData}
        isLoading={isLoading}
        tableContainerProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "none",
            maxHeight: 320,
            p: 0,
          },
        }}
        tableProps={{
          size: "small",
          "aria-label": "on-time start end table",
          sx: {
            background: "transparent",
            "& thead th": {
              color: "#1E1B39",
              fontWeight: "bold",
              fontSize: 14,
              border: "none",
            },
            "& thead th:first-of-type": {
              paddingLeft: 0,
            },
            "& td": {
              fontSize: 14,
              color: "#1D1B20",
              paddingLeft: 0,
            },
          },
        }}
        stickyHeader
        tableHeight={320}
        disableSorting={true}
        transparentRows={true}
      />
    </>
  );
};

export default TableChart;
